module.exports = __webpack_public_path__ + "static/media/19ESCAP20.ac0f710b.jpg";